import React, { FC } from 'react';

import classNames from 'classnames';

import { DynamicComponent, Seo } from '@/components';

import { buildCanonicalUrl } from '@/core/contentfulConfig';
import { TypeProductLandingPage } from '@/core/generated-types';

const ProductLandingPageLayout: FC<TypeProductLandingPage> = (page) => {
  const {
    fields: { title, components, description, enableInternalSticky },
  } = page;

  const metadataFields = page.fields?.seoMetadata?.fields;

  return (
    <>
      <Seo
        title={metadataFields?.pageTitle}
        description={metadataFields?.pageDescription}
        nofollow={metadataFields?.noFollow}
        noindex={metadataFields?.noIndex}
        canonical={buildCanonicalUrl(page)}
      />
      <div
        className={classNames({
          'overflow-hidden': !enableInternalSticky,
        })}
      >
        {title && (
          <h1 className="container mx-auto mt-8 text-center text-h-x3 font-bold">
            {title}
          </h1>
        )}

        {description && <p className="container mx-auto">{description}</p>}

        <div>
          {components?.map((component) => (
            <DynamicComponent key={component.sys.id} component={component} />
          ))}
        </div>
      </div>
    </>
  );
};

export default ProductLandingPageLayout;
